import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=b836f12c&scoped=true&"
import script from "./AttributesTable.vue?vue&type=script&lang=js&"
export * from "./AttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=b836f12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836f12c",
  null
  
)

export default component.exports